// Helpers to render/download receipt files consistently across pages.
// Handles two production edge cases:
//  1. The Kubernetes ingress only forwards `/api/*` to the backend, so legacy
//     receipts stored with a raw `/uploads/...` prefix must be rewritten to
//     `/api/uploads/...` before the browser fetches them.
//  2. Mobile camera formats (HEIC/HEIF) cannot be rendered by <img>; we detect
//     these so the modal can show a friendly download-only fallback.

const BACKEND = process.env.REACT_APP_BACKEND_URL || "";

export function receiptUrl(fileUrl) {
  if (!fileUrl) return "";
  if (/^https?:\/\//i.test(fileUrl)) return fileUrl;
  let normalized = fileUrl;
  if (normalized.startsWith("/uploads/")) normalized = "/api" + normalized;
  if (!normalized.startsWith("/")) normalized = "/" + normalized;
  return `${BACKEND}${normalized}`;
}

export function isImageMime(mime = "", filename = "") {
  const m = (mime || "").toLowerCase();
  if (m.startsWith("image/")) return !isHeic(m, filename);
  return /\.(png|jpe?g|gif|webp|bmp)$/i.test(filename || "");
}

export function isHeic(mime = "", filename = "") {
  const m = (mime || "").toLowerCase();
  if (m === "image/heic" || m === "image/heif") return true;
  return /\.(heic|heif)$/i.test(filename || "");
}

export function isPdf(mime = "", filename = "") {
  const m = (mime || "").toLowerCase();
  if (m === "application/pdf") return true;
  return /\.pdf$/i.test(filename || "");
}
